import { render, staticRenderFns } from "./HistoryMovementModal.vue?vue&type=template&id=021ab58f&"
import script from "./HistoryMovementModal.vue?vue&type=script&lang=js&"
export * from "./HistoryMovementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports